import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllTolls = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/tolls',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveTolls = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/tolls',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateTolls = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/tolls/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteTolls = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/tolls/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllTolls,
  saveTolls,
  deleteTolls,
  updateTolls,
}
